import { isAxiosError } from 'axios';
import type { ErrorResponse } from '@src/core/buyerApiClient';

export function classifyRescheduleError(error: unknown): string[] {
  if (!isAxiosError<ErrorResponse>(error)) return [];
  if (error.response?.status !== 422) return [];

  const errors = error.response.data?.errors ?? [];

  return errors.map((item) => item.type).filter((type): type is string => Boolean(type));
}
